module.exports = __webpack_public_path__ + "static/Eficiencia-f1aeeb11bb3b6e9cda58f9d853afda1d.gif";